var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.292,
    height: 88.292,
    viewBox: "0 0 88.292 88.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_414",
    "data-name": "Ellipse 414",
    cx: 44.146,
    cy: 44.146,
    r: 44.146,
    transform: "translate(0 0)",
    fill: "#44c4a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6355",
    "data-name": "Path 6355",
    d: "M123.831,110.145,92.623,141.353,77.309,126.04l-7.775,7.774L92.623,156.9l38.983-38.985Z",
    transform: "translate(-56.424 -89.378)",
    fill: "#ebf0f3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.8f591f7767c733f3dcfb5357a3434818.svg";
export { ForwardRef as ReactComponent };